import { LearningItemStatus } from '../../models/BaseModels'
import * as api from '../api'
import useInvalidate from '../useInvalidate'
import useApiMutation from './useApiMutation'

type UpdateOnDemandCourseArgs = {
  status?: LearningItemStatus
  uuid: string
  title?: string
  description?: string
  image?: string | null | undefined
  categoryUuids?: string[]
  providerUuid?: string
  isGlobalProvider?: boolean
  clientUuid?: string | null | undefined
  createCertificate?: boolean
  certificateValidUntil?: Date | null | undefined
  durationInMin?: number
  contentLocales?: string[]
}

export default function useUpdateOnDemandCourse() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async (data: UpdateOnDemandCourseArgs) => {
      const result = await api.patch(`on-demand-course/${data.uuid}`, {
        status: data.status,
        title: data.title,
        description: data.description,
        image: data.image,
        categories: data.categoryUuids,
        provider_uuid: data.providerUuid,
        is_global_provider: data.isGlobalProvider,
        client_uuid: data.clientUuid,
        create_certificate: data.createCertificate,
        certificate_valid_until: data.certificateValidUntil,
        duration_in_min: data.durationInMin,
        content_locales: data.contentLocales,
      })

      invalidate.courses()

      return result
    },
  })
}
